import { ParamHistorical } from '../../../../../shared/types/param';

export interface Submotive2HistoricalProps {
    historical: ParamHistorical[];
    showHistorical?: boolean;
}

export const fieldEquivalences: { [key: string]: string } = {
    createAt: 'Fecha de creación',
    name: 'Nombre',
    extra2: 'Descripción',
    active: 'Estado',
    parent: 'Submotivo 1',
    nestedParent: 'Motivo',
    nestedParent2: 'Tipo PQR',
};
